import { useCurrentCart } from "Store/cart/cartHooks";
import { InsuranceProduct } from "Store/interfaces/products/checkout";

export const useProducts = (
  showAll = false,
  visible = false,
): InsuranceProduct[] => {
  const cart = useCurrentCart();

  if (!cart) {
    return [];
  }

  const { products = [] } = cart;

  if (showAll) {
    return products;
  }

  return products.filter((item) => item.visible === visible);
};
